import { z } from "zod/v4";

export const bankProviderSchema = z.enum(["manual", "banksapi", "enable_banking"]);

export const bankMatchStatusSchema = z.enum([
	"unmatched",
	"auto_matched",
	"manually_matched",
	"ignored",
]);

export const bankAccountResponseSchema = z.object({
	id: z.string(),
	club_id: z.string(),
	name: z.string(),
	iban: z.string().nullable().optional(),
	bank_name: z.string().nullable().optional(),
	provider: bankProviderSchema,
	last_synced_at: z.coerce.date().nullable().optional(),
	created_at: z.coerce.date(),
	updated_at: z.coerce.date(),
});

export const bankTransactionResponseSchema = z.object({
	id: z.string(),
	bank_account_id: z.string(),
	external_id: z.string().nullable().optional(),
	transaction_date: z.coerce.date(),
	amount_cents: z.number(),
	currency: z.string(),
	counterparty_name: z.string().nullable().optional(),
	counterparty_iban: z.string().nullable().optional(),
	reference: z.string().nullable().optional(),
	match_status: bankMatchStatusSchema,
	matched_invoice_id: z.string().nullable().optional(),
	matched_booking_id: z.string().nullable().optional(),
	imported_at: z.coerce.date(),
	created_at: z.coerce.date(),
});

export const importResultSchema = z.object({
	imported: z.number(),
	skipped: z.number(),
	total: z.number(),
});

export const matchResultSchema = z.object({
	transaction_id: z.string(),
	invoice_id: z.string(),
	confidence: z.string(),
});

export const createBankAccountSchema = z.object({
	name: z.string().min(1, "Name is required"),
	iban: z.string().optional(),
	bank_name: z.string().optional(),
});

export const updateBankAccountSchema = z.object({
	name: z.string().min(1).optional(),
	iban: z.string().optional(),
	bank_name: z.string().optional(),
});
